import 'element-closest';
import { removeClasses } from './utils';
import arrayFrom from 'array-from';

const URL = 'website-header/website.html';
const mq = window.matchMedia('(min-width: 1200px)');
const AUTOPLAY_DELAY = 8000;

class HeroIframe {
  constructor () {
    this.state = {
      currentSlide: -1,
      isPaused: true,
      autoplay: true,
      loaded: false,
      interval: null,
      isAnimationError: false
    };

    const els = this.els = {
      heroEl: document.querySelector('.c-hero'),
      dotNavigationEl: document.querySelector('.js-hero-iframe-navigation'),
      iframeEl: document.querySelector('iframe.c-hero__content'),
      scrollToTop: document.querySelectorAll('.js-hero-iframe-scrolltop'),
    };
    this.slidesCount = els.dotNavigationEl.children.length;
    const isDisbale = /disableHero/.test(window.location.search);
    const waitForMq = () => {
      if (mq.matches) {
        this.enableIframe(els.iframeEl, els.heroEl);
        window.removeEventListener('resize', waitForMq, false);
      }
    };

    if (!els.heroEl || !els.iframeEl || isDisbale) {
      return;
    }

    window.addEventListener('resize', waitForMq, false);
    waitForMq();

    window.addEventListener('message', event => {
      if (event.data === 'website-header-error') {
        this.disableIframe(els.iframeEl, els.heroEl);
      }
      if (event.data === 'loaded') {
        this.setupNavLure();
      }
    }, false);

    els.dotNavigationEl.addEventListener('click', event => {
      event.preventDefault();
      this.handleDotNavigationClick(event.target, els);
    }, false);

    arrayFrom(els.scrollToTop).forEach(element => {
      element.addEventListener('click', event => {
        const exhibitId = event.target.closest('.js-hero-iframe-scrolltop')
          .getAttribute('data-scroll-exhibit');
        this.setState({ currentSlide: Number(exhibitId) - 1 });
      });
    });
  }

  setupNavLure() {
    const interval = setTimeout(() => {
      this.els.dotNavigationEl.children[1].classList.add('is-lure');
    }, AUTOPLAY_DELAY);

    this.setState({loaded: true, interval});
  }

  handleDotNavigationClick (target, els) {
    const dotEl = target.closest('.c-hero__dot');
    const { dotNavigationEl } = els;

    if (dotEl) {
      const index = Array.prototype.indexOf.call(dotNavigationEl.children, dotEl);

      this.setState({ currentSlide: index - 1, autoplay: false });

      if (index === 0) {
        els.iframeEl.contentWindow.postMessage('goToGlobe', '*');
      }
    }
  }

  enableIframe (iframeEl, heroEl) {
    heroEl.classList.add('is-iframe');
    heroEl.classList.add('is-loading');
    iframeEl.src = URL;
    iframeEl.addEventListener('load', () => {
      if (!this.state.isAnimationError) {
        iframeEl.classList.add('is-loaded');
        this.toggleIframe(iframeEl, heroEl);
        window.addEventListener('scroll', () => {
          this.toggleIframe(iframeEl, heroEl);
        });
      }
    });
  }

  disableIframe (iframeEl, heroEl) {
    this.setState({ isAnimationError: true });
    heroEl.classList.remove('is-iframe');
    heroEl.classList.remove('is-loading');
    iframeEl.classList.remove('is-loaded');
    iframeEl.src = '';
  }

  toggleIframe (iframeEl, heroEl) {
    if (window.pageYOffset >= heroEl.clientHeight && !this.state.isPaused) {
      this.setState({ isPaused: true });
      iframeEl.contentWindow.postMessage('pause', '*');
    }

    if (window.pageYOffset < heroEl.clientHeight && this.state.isPaused) {
      this.setState({ isPaused: false });
      iframeEl.contentWindow.postMessage('play', '*');
    }
  }

  updateSlide () {
    const { els } = this;
    const { currentSlide, loaded } = this.state;
    const noop = () => {};

    if (!loaded) {
      return;
    }

    const currentDot = els.dotNavigationEl.children[currentSlide + 1];

    if (currentSlide === -1) {
      noop();
    } else if (currentSlide === this.slidesCount - 1) {
      return
    } else {
      els.iframeEl.contentWindow.postMessage(`animateTo=${currentSlide}`, '*');
    }
    removeClasses(els.dotNavigationEl.children, 'active');
    removeClasses(els.dotNavigationEl.children, 'is-lure');

    if (currentDot) {
      currentDot.classList.add('active');
    }
  }

  setState(newState: Object) {
    this.state = Object.assign({}, this.state, newState);
    this.updateSlide();
  }
}

export default HeroIframe;
